import { FunctionComponent } from "react";
import {Button, Card, Grid} from "@mui/material";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { TeamMember as TeamMemberProps } from "../../types";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { media } from "../../../styles/styles";
import { actions as appActions } from "../../redux/app";
import ArrowLink from "./ArrowLink";

interface Props {
  teamMember: TeamMemberProps;
}
const Content = styled(Grid)`
  && {
    padding: 0 1rem;
  }
  i {
    color: #e55934;
  }
`;
const Accomplishments = styled(Card)`
  && {
    background-color: #f0f0f0;
    padding: 1rem;
    ul {
      padding-left: 1em;
    }
  }
`;
const ImageWrapper = styled(Grid)`
  && {
    width: 100%;
    > div {
      margin: 1rem 0;
    }
    font-size: 1rem;
    img {
      width: 100%;
    }
    ${media.phone`
    text-align:center;
    img {
      width: 75%;
    }
`}
  }
`;
const Wrapper = styled(Grid)`
  && {
    margin: 2rem 0;
    > div {
      margin: 1rem 0;
    }
  }
`;
const Title = styled.div`
  h2 {
    margin: 0;
  }
  div {
    font-size: 1.2rem;
  }
`;
const TeamMember: FunctionComponent<Props> = ({ teamMember }) => {
  const dispatch = useDispatch();

  return (
    <Wrapper container justifyContent="space-around">
      <Grid item sm={9}>
        <Grid container justifyContent="space-around">
          <ImageWrapper item sm={3} xs={12}>
            {teamMember.portraitImage && (
              <img
                src={teamMember.portraitImage.fields.file.url}
                alt={teamMember.portraitImage.fields.title}
              />
            )}
            <Button
              variant="text"
              onClick={() => dispatch(appActions.toggleModal())}
            >
              <ArrowLink>
                Contact{" "}
                {teamMember.fullName.substr(
                  0,
                  teamMember.fullName.indexOf(" ")
                )}
              </ArrowLink>
            </Button>
          </ImageWrapper>
          <Content item sm={9} xs={12}>
            <Title>
              <h2>{teamMember.fullName}</h2>
              <div>{teamMember.positions.map((pos, ind) => `${pos}${ind+1 !== teamMember.positions?.length ? ',' : ''} `)}</div>
            </Title>
            <div>{documentToReactComponents(teamMember.content)}</div>
          </Content>
        </Grid>
      </Grid>
      <Grid item sm={3} xs={12}>
        <Accomplishments elevation={0}>
          <h3>Memberships and Associations</h3>
          <div>
            {teamMember.membershipsAssociations &&
              documentToReactComponents(teamMember.membershipsAssociations)}
          </div>
        </Accomplishments>
      </Grid>
    </Wrapper>
  );
};
export default TeamMember;
/*
fullName: item.fields.fullName,
quote: item.fields.quote,
portraitImage: item.fields.portraitImage || null,
summary: item.fields.summary,
content: item.fields.content || null,
state: item.fields.state,
membershipsAssociations: item.fields.membershipsAssociations,
positions: item.fields.positions,*/
